/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */
import BodyFree from './body/BodyFree';
import FreeLabel from './body/free/FreeLabel';
import FreeTextarea from './body/free/FreeTextarea';

/**
 * survey - inquiry > free comment component 作成します
 * @param {*} textareaRef React.ref - textarea.ref に設定します
 * @param {*} inquiry config.inquiry 設定
 * @param {*} props React.props - textarea へ設定します
 * @return {*} React.node - free comment component
 * @constructor
 */
export const FreeComment = ({ textareaRef, inquiry, ...props }) => {
  const [value, setValue] = useState('');

  const onChange = useCallback(() => {
    if (!textareaRef.current) {
      return;
    }
    setValue(textareaRef.current.value);
  }, [setValue, textareaRef]);

  return (
    <BodyFree>
      {inquiry.checkList.available && (
        // checkbox question 無い時は title 位置に表示する
        <FreeLabel
          isActive={textareaRef.current && textareaRef.current.value}
          label={inquiry.freeInput.title}
        />
      )}
      <FreeTextarea
        ref={textareaRef}
        name={inquiry.freeInput.name}
        onChange={onChange}
        value={value}
        {...props}
      />
    </BodyFree>
  );
};

export default FreeComment;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/FreeComment.js